import { IncomingMessage } from 'http';

import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import fetchCart from '../../../services/cart/get-cart';
import { getCartKeys } from '../query-keys';

const getCart = (
  options: {
    locale: string;
    isAdvancedView?: boolean;
    detailedPrice?: boolean;
  },
  req?: IncomingMessage
): [
  QueryKey,
  (options: QueryFunctionContext) => ReturnType<typeof fetchCart>
] => [
  getCartKeys(options),
  ({
    queryKey: [, , locale, isAdvancedView, detailedPrice],
  }: {
    queryKey: string[];
  }) =>
    fetchCart(
      {
        locale,
        is_advanced_view: isAdvancedView,
        detailed_prices: detailedPrice,
      },
      req
    ),
];

export default getCart;
